export const environment = {
  production: false,
  serverUrl: 'https://questionari-api.dev.sostenibile.cloud',
  serverGo: 'https://questionari-api.dev.go.sostenibile.cloud',
  url: 'https://admin.dev.sostenibile.cloud',
  urlGo: 'https://admin.dev.go.sostenibile.cloud',
  serverAI: 'https://agent-chat-server.develop.aip.zcscloud.dev',
  folliaUrl: 'https://aip-agents-api.develop.aip.zcscloud.dev',
  dataSourceDefault: '695e3e73b751bf76ad828f87',
};
